import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import { Button } from "@material-ui/core";
import CreateIcon from "@material-ui/icons/Create";
import UserSurveyWriteContainer from "./containers/UserSurvey/UserSurveyWriteContainer";
import COVID19WriteContainer from "./containers/COVID19/COVID19WriteContainer";
import * as api from "../apis/SignList";
import session from "../lib/sessionStorage";

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  alignCenter: {
    "& > *": {
      margin: theme.spacing(1),
    },
    textAlign: "center",
  },
}));

const Write = ({ history }) => {
  const classes = useStyles();
  const [documentType, setDocumentType] = useState("");
  const [language, setLanguage] = useState("ko");
  const [data, setData] = useState(null);
  const [applyChecker, setApplyChecker] = useState(false);

  const handleChange = (event) => {
    setDocumentType(event.target.value);
  };

  const handleChangeLang = (event) => {
    setLanguage(event.target.value);
  };

  const onApplyChecker = (flag) => {
    setApplyChecker(flag);
  };

  const onCreate = () => {
    console.log("onCreate 호출됨, data:", data);
    console.log("data가 배열인가?", Array.isArray(data));

    // 토큰 상태 확인
    const token = session.get("token");
    const isLogin = session.get("isLogin");
    const userIdx = session.get("userIdx");
    console.log("토큰 상태:", {
      token: token ? "존재함" : "없음",
      isLogin,
      userIdx,
    });

    // 데이터가 배열인지 확인 (다중 대상자)
    if (Array.isArray(data)) {
      console.log("다중 대상자 모드, 데이터 개수:", data.length);
      // 백엔드 API가 아직 구현되지 않은 경우를 대비해 개별 호출로 처리
      const createMultipleSignatures = async () => {
        try {
          let successCount = 0;
          let failCount = 0;

          for (const signData of data) {
            console.log("개별 문서 생성 시도:", signData);
            try {
              const res = await api.postAddSign(signData);
              console.log("API 응답:", res);
              if (res && res.data && res.data.result) {
                successCount++;
                console.log("성공:", successCount);
              } else {
                failCount++;
                console.log("실패 (result false):", failCount, res);
              }
            } catch (error) {
              console.error("Individual sign creation error:", error);
              failCount++;
              console.log("실패 (예외):", failCount);
            }
          }

          console.log("최종 결과 - 성공:", successCount, "실패:", failCount);
          if (successCount > 0) {
            alert(
              `${successCount}개의 서명 문서가 생성되었습니다.${
                failCount > 0 ? ` (${failCount}개 실패)` : ""
              }`
            );
            history.push("/list");
          } else {
            alert("모든 문서 생성에 실패했습니다.");
          }
        } catch (error) {
          console.error("Multiple sign creation error:", error);
          alert("문서 생성 중 오류가 발생했습니다.");
        }
      };

      createMultipleSignatures();
    } else {
      console.log("단일 대상자 모드, data:", data);
      // 단일 대상자 처리 (기존 로직)
      api
        .postAddSign(data)
        .then((res) => {
          console.log("단일 문서 생성 API 응답:", res);
          if (res && res.data && res.data.result) {
            history.push("/list");
          } else {
            console.log("단일 문서 생성 실패:", res);
            alert("문서 생성에 실패했습니다.");
          }
        })
        .catch((error) => {
          console.error("단일 문서 생성 오류:", error);
          alert("문서 생성 중 오류가 발생했습니다.");
        });
    }
  };

  const setTemplateDocument = () => {
    switch (documentType) {
      case "userSurvey":
        // 사용자조사 개인정보 관련
        return (
          <UserSurveyWriteContainer
            data={(value) => setData(value)}
            applyChecker={onApplyChecker}
            lang={language}
          />
        );
      case "covid19":
        // 코로나바이러스감염증-19(COVID-19) 관련 사실 확인 여부
        return (
          <COVID19WriteContainer
            data={(value) => setData(value)}
            applyChecker={onApplyChecker}
            lang={language}
          />
        );
      default:
        return (
          <UserSurveyWriteContainer
            data={(value) => setData(value)}
            applyChecker={onApplyChecker}
            lang={language}
          />
        );
      // return <COVID19WriteContainer data={(value) => setData(value)} applyChecker={onApplyChecker}/>
    }
  };

  return (
    <div>
      <div>
        <FormControl variant="outlined" className={classes.formControl}>
          <InputLabel id="documentType">Type</InputLabel>
          <Select
            labelId="documentType"
            id="documentType"
            value={documentType}
            onChange={handleChange}
            label="Type"
          >
            <MenuItem value={"userSurvey"}>사용자조사 개인정보 관련</MenuItem>
            <MenuItem value={"covid19"}>
              코로나바이러스 감염증 관련 사실확인 여부
            </MenuItem>
            {/*<MenuItem value={2}>보안 서약서</MenuItem>*/}
          </Select>
        </FormControl>
        <FormControl variant="outlined" className={classes.formControl}>
          <InputLabel id="language">언어선택</InputLabel>
          <Select
            labelId="language"
            id="language"
            value={language}
            onChange={handleChangeLang}
            label="language"
          >
            <MenuItem value={"ko"} selected>
              국문
            </MenuItem>
            <MenuItem value={"en"}>영문</MenuItem>
          </Select>
        </FormControl>
      </div>
      <div>{setTemplateDocument()}</div>
      <div className={classes.alignCenter}>
        {/*<Button*/}
        {/*	variant="contained"*/}
        {/*	startIcon={<VisibilityIcon/>}*/}
        {/*	onClick={onPreview}*/}
        {/*>*/}
        {/*	Preview*/}
        {/*</Button>*/}
        <Button
          variant="contained"
          color="primary"
          disabled={!applyChecker}
          startIcon={<CreateIcon />}
          onClick={onCreate}
        >
          Create
        </Button>
      </div>
    </div>
  );
};

export default Write;
